import './NPLink.css'

export function NPLink({ text, href }) {

    return (
        <a className="np-link" href={href}>{text}</a>
    )

}